// extracted by mini-css-extract-plugin
module.exports =  {"tags":"_93444fe79c--tags--ybhTH","tags_wrapper":"_93444fe79c--tags_wrapper--Sy5H8","tags_item":"_93444fe79c--tags_item--tyk4W"};